'use strict';
exports.test = function () {
  return true;
};

exports.install = function (t) {
  return function () {
    setTimeout(t, 0);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/immediate/lib/timeout.js
// module id = 465
// module chunks = 0